import React, {Component} from 'react';
import * as func from "../../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../../wpconfig"

class PCodeItem extends Component {
	constructor(props) {
		super(props);

		const r = JSON.parse(JSON.stringify(this.props.record));

		this.state = {
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record : r
		}
	}

	keyUp = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record);
	}

	checked = () => {
		const record = this.props.record;

		if(event.target.checked) {
			record[event.target.name] = 'N';
		} else {
			record[event.target.name] = 'Y';
		}
		this.props.onUpdate(this.props.arrIndex, record);
	}

	onEditSave = (e) => {
		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}
		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (this.props.record.up_code_id) {
				func.updateData("code/update", this.props.record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({
							record : JSON.parse(JSON.stringify(this.props.record))
						})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				let record = this.props.record;
				if (this.code_id.value === '') {
					this.code_id.focus();
				} else if (record.code_name === '') {
					this.code_name.focus();
				} else {
					record.code_id = this.code_id.value;
					record.up_code_id = 'root';
					delete record.is_edit;
					func.updateData("code/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.props.showMessage('추가 되었습니다.');
							this.props.onReload();
						} else {
							record.code_id = '';
							record.up_code_id = '';
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onCloseDelete = (e) => {
		const record = this.props.record;
		if (record.up_code_id) {
			if (this.state.isEdit) {
				this.props.onUpdate(this.props.arrIndex, this.state.record);
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm(record.code_name + '코드를 ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData("code/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onEdit = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
	};

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record.up_code_id) {
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	};

	onChildCode = (e) => {
		this.props.onChildCode(this.props.record.code_id);
	}

	render() {
		const record = this.props.record;

		return (
			<>
				{this.state.isEdit === EDIT_MODE.SHOW ?
					<tr>
						<td>
							<a className={this.props.selectChildCodeId === record.code_id ? 'active' : ''}
							   onClick={this.onChildCode}>{record.code_id}</a>
						</td>
						<td>
							<span onClick={this.onChildCode}>{record.code_name}</span>
						</td>
							{this.props.delYn === 'N' &&
						<td>
							<div className="btn-group">
								<button type="button" className="btn btn-outline-success btn-sm" onClick={this.onEditSave}>수정</button>
								<button type="button" className="btn btn-outline-danger btn-sm" onClick={this.onCloseDelete}>삭제</button>
							</div>
						</td>
							}
					</tr>
					:
					<tr>
						<td colSpan="3" className="edit-row">
							<div className="">
								<h6>코드 {record.up_code_id ? '수정' : '추가'}</h6>
								<div className="row mb-2">
									<div className="col-md-6 form-group">
										<label htmlFor="code_id"><strong>코드ID</strong></label>
										{!record.up_code_id ?
											<input type="text" name="code_id" ref={(ref)=>this.code_id=ref} defaultValue={record.code_id} className="form-control" />
											: <label className="d-block">{record.code_id}</label> }
									</div>
									<div className="col-md-6 form-group">
										<label htmlFor="code_name"><strong>코드 이름</strong></label>
										<input type="text" name="code_name" ref={(ref)=>this.code_name=ref} value={record.code_name} onChange={this.keyUp} className="form-control" />
									</div>
								</div>
								<div className="row mb-2">
									<div className="col-md-4 form-group">
										<label htmlFor="code_name_eng"><strong>코드 이름(영문)</strong></label>
										<input type="text" name="code_name_eng" className="form-control" value={record.code_name_eng || ''} onChange={this.keyUp}/>
									</div>
									<div className="col-md-8 form-group">
										<label htmlFor="code_desc"><strong>코드 설명</strong></label>
										<input type="text" name="code_desc" className="form-control" value={record.code_desc || ''} onChange={this.keyUp}/>
									</div>
								</div>
								<div className="row mb-2">
									<div className="col-md-4 form-group">
										<label htmlFor="visible_seq"><strong>순서</strong></label>
										<input type="text" name="visible_seq" className="form-control" value={this.visible_seq} onChange={this.keyUp}/>
									</div>
									{/*<div className="col-md-4 form-group">*/}
									{/*	<label htmlFor=""><strong>출력여부</strong></label>*/}
									{/*	<div className="mt-1">*/}
									{/*		<div className="form-check form-check-inline">*/}
									{/*			<input className="form-check-input" type="checkbox" name="disp_yn" id="disp_yn" checked={record.disp_yn !== 'Y'} onChange={this.checked} />*/}
									{/*			<label className="form-check-label" htmlFor="disp_yn">출력안함</label>*/}
									{/*		</div>*/}
									{/*	</div>*/}
									{/*</div>*/}
									{/*<div className="col-md-4 form-group">*/}
									{/*	<label htmlFor=""><strong>삭제-팀장님</strong></label>*/}
									{/*	<div className="mt-1">*/}
									{/*		<div className="form-check form-check-inline">*/}
									{/*			/!*<input className="form-check-input" type="checkbox" name="del_yn" id="del_yn" checked={record.del_yn === 'Y'} />*!/*/}
									{/*			<label className="form-check-label" htmlFor="del_yn">삭제</label>*/}
									{/*		</div>*/}
									{/*	</div>*/}
									{/*</div>*/}
								</div>
								<div className="btn-group float-right">
									<button type="button" className="btn btn-outline-primary btn-sm" onClick={this.onEditSave}>저장</button>
									<button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.onCloseDelete}>{record.up_code_id ? '닫기' : '취소'}</button>
								</div>
							</div>
						</td>
					</tr>
				}
			</>
		)
	}
}

export default PCodeItem;